<div class="sub-header px-3">
    <app-breadcrumb [breadcrumbs]="breadcrumbs"></app-breadcrumb>
</div>
<div class="search-container py-3 align-items-center d-flex row mb-0 px-3 mb-2 pb-4">
    <div class="col-md-5 category-header d-flex px-3 py-1">
        <span nzType="arrow-left" nz-icon [routerLink]="['/content-dashboard']"> </span>
        <h5 class="mb-0 px-4">{{apiService.contentPageDesc }}</h5>
    </div>
    <div class="col-md-7 search-input-block d-flex align-items-center justify-content-around">
        <nz-input-group class="px-2 search-input-group" style="width: 65%;" nzSize="default"
            [nzSuffix]="suffixIconSearch">
            <input type="text" class="py-1" nz-tooltip nz-input [placeholder]="
           (apiService.contentPageType == 'W' || apiService.contentPageType == 'N') ?
           'Search by Name, EDP/AR #, Program or Workgroup'
            : 'Search by Name or EDP/AR #'" [nzTooltipTitle]="
           (apiService.contentPageType == 'W' || apiService.contentPageType == 'N') ?
           'Search by Name, EDP/AR #, Program or Workgroup'
            : 'Search by Name or EDP/AR #'"
                (keydown.enter)="filterContentList(SearchText.value)" [(ngModel)]="searchText"
                (ngModelChange)="filterContentList(SearchText.value)" nzAllowClear #SearchText />
            <span class="close-icon" (click)="SearchText.value = '';filterContentList('')" class="px-1" nz-icon
                nzType="close-circle"></span>
        </nz-input-group>
        <ng-template #suffixIconSearch>
            <span class="search-icon" (click)="filterContentList(SearchText.value)" nz-icon nzType="search"></span>
        </ng-template>

        <button nz-button>
            <span nz-icon (click)="sortContentList()" [nzType]="sortDirAsc ? 'sort-ascending': 'sort-descending'"></span>
        </button>
        <button nz-button nzType="primary" [routerLink]="['/content-page', pageType]"
            class="d-flex align-items-center" [nzSize]="'default'">
            <span nz-icon nzType="plus"></span>New Content
        </button>
    </div>
</div>

<app-spinner *ngIf="!dataLoaded"></app-spinner>
<div class="px-3 py-3" *ngIf="dataLoaded">
    <ng-container *ngIf="contentListData.length == 0">
        <div class="catalog-title mt-3 mb-3 py-1">
            No records found!
        </div>
    </ng-container>
    <cdk-virtual-scroll-viewport itemSize="contentListData.length" class="demo-infinite-container mt-2 border-0">
        <div *cdkVirtualFor="let headerId of groupedHeaderList">
            <ng-container>
                <div class="catalog-title mt-3 mb-3 py-1">
                    {{ headerId }}
                </div>
            </ng-container>
            <ng-container *ngFor="let category of displayContentListData[headerId]; trackBy: trackByFn">
                <ul nz-list class="catalog-list" [nzDataSource]="contentListData" nzBordered nzSize="large">
                    <li nz-list-item nzNoFlex [ngClass]="category.hover ? 'hoverOptions':''"
                        (mouseenter)="category.hover = true" (mouseleave)="category.hover = false">
                        <ul nz-list-item-actions>
                            <nz-list-item-action>
                               &nbsp;
                                <!-- <span nz-dropdown (click)="showDelete(category['seqNo'])" class="px-2 py-2" nz-icon
                                    nzType="delete"></span> -->
                                     <!-- </button> -->
              <button nz-button (click)="showDelete(category)">
                <span style="color:black" nz-icon [nzType]="'delete'"></span>
              </button>
                              
                            </nz-list-item-action>
                        </ul>

                        <div [routerLink]="['/content-page', pageType, category['seqNo']]"
                            class="d-flex catalog-box justify-content-center align-items-center"
                            (click)="redirect(category)">
                            <nz-avatar [nzText]="category['contentShortDesc'][0]"
                                style="color:#f56a00; background-color:#fde3cf;"></nz-avatar>
                            <h6 class="my-custom-pointer mb-0 px-3">{{ category['contentShortDesc'] }}</h6>
                        </div>
                    </li>
                </ul>
            </ng-container>
        </div>
    </cdk-virtual-scroll-viewport>
</div>

